module.exports = __webpack_public_path__ + "fonts/AvenirNextCyr-Demi.7d124afd.eot";